import React from 'react';
import { Box, Button, Divider } from '@mui/material';
import {
  Notes as TextIcon,
  Title as HeadingIcon,
  Info as CalloutIcon,
  Code as CodeIcon,
  Image as ImageIcon,
  Videocam as VideocamIcon,
  Checklist as ChecklistIcon,
  HorizontalRule as DividerIcon,
  GridView as GridViewIcon,
} from '@mui/icons-material';
import { BlockType } from '../../../types/blocks';

interface AddBlockToolbarProps {
  onAdd: (type: BlockType) => void;
}

const blockButtons: { type: BlockType; label: string; icon: React.ReactElement }[] = [
  { type: 'text', label: 'Text', icon: <TextIcon sx={{ fontSize: 16 }} /> },
  { type: 'heading', label: 'Heading', icon: <HeadingIcon sx={{ fontSize: 16 }} /> },
  { type: 'callout', label: 'Callout', icon: <CalloutIcon sx={{ fontSize: 16 }} /> },
  { type: 'code', label: 'Code', icon: <CodeIcon sx={{ fontSize: 16 }} /> },
  { type: 'image', label: 'Image', icon: <ImageIcon sx={{ fontSize: 16 }} /> },
  { type: 'image-grid', label: 'Image Grid', icon: <GridViewIcon sx={{ fontSize: 16 }} /> },
  { type: 'video', label: 'Video', icon: <VideocamIcon sx={{ fontSize: 16 }} /> },
  { type: 'checklist', label: 'Checklist', icon: <ChecklistIcon sx={{ fontSize: 16 }} /> },
  { type: 'divider', label: 'Divider', icon: <DividerIcon sx={{ fontSize: 16 }} /> },
];

const AddBlockToolbar: React.FC<AddBlockToolbarProps> = ({ onAdd }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, py: 1 }}>
      <Divider sx={{ flex: 1 }} />
      <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap', justifyContent: 'center' }}>
        {blockButtons.map((btn) => (
          <Button
            key={btn.type}
            size="small"
            variant="outlined"
            startIcon={btn.icon}
            onClick={() => onAdd(btn.type)}
            sx={{
              fontSize: '0.6875rem',
              textTransform: 'none',
              py: 0.25,
              px: 1,
              minWidth: 'auto',
              borderColor: 'divider',
              color: 'text.secondary',
              '&:hover': {
                borderColor: 'primary.main',
                color: 'primary.main',
                bgcolor: 'action.hover',
              },
            }}
          >
            {btn.label}
          </Button>
        ))}
      </Box>
      <Divider sx={{ flex: 1 }} />
    </Box>
  );
};

export default AddBlockToolbar;
